// extracted by mini-css-extract-plugin
export default {"container":"ExpressDropoffLogoImage-module__container--rd1si","logoImage":"ExpressDropoffLogoImage-module__logoImage--7br4M"};